__turbopack_context__.v({
  "about": "retail-module__fNDrra__about",
  "aboutDescription": "retail-module__fNDrra__aboutDescription",
  "aboutGrid": "retail-module__fNDrra__aboutGrid",
  "addressLines": "retail-module__fNDrra__addressLines",
  "attribution": "retail-module__fNDrra__attribution",
  "benefit": "retail-module__fNDrra__benefit",
  "benefits": "retail-module__fNDrra__benefits",
  "buyButton": "retail-module__fNDrra__buyButton",
  "campaign": "retail-module__fNDrra__campaign",
  "cartButton": "retail-module__fNDrra__cartButton",
  "cartIcon": "retail-module__fNDrra__cartIcon",
  "categories": "retail-module__fNDrra__categories",
  "categoryCard": "retail-module__fNDrra__categoryCard",
  "categoryGrid": "retail-module__fNDrra__categoryGrid",
  "categoryMedia": "retail-module__fNDrra__categoryMedia",
  "compactCard": "retail-module__fNDrra__compactCard",
  "contactLine": "retail-module__fNDrra__contactLine",
  "container": "retail-module__fNDrra__container",
  "empty": "retail-module__fNDrra__empty",
  "eyebrow": "retail-module__fNDrra__eyebrow",
  "favorite": "retail-module__fNDrra__favorite",
  "filters": "retail-module__fNDrra__filters",
  "footer": "retail-module__fNDrra__footer",
  "footerBottom": "retail-module__fNDrra__footerBottom",
  "footerColumns": "retail-module__fNDrra__footerColumns",
  "footerColumnsWithoutSocials": "retail-module__fNDrra__footerColumnsWithoutSocials",
  "footerDescription": "retail-module__fNDrra__footerDescription",
  "footerIdentity": "retail-module__fNDrra__footerIdentity",
  "footerLegal": "retail-module__fNDrra__footerLegal",
  "footerPayments": "retail-module__fNDrra__footerPayments",
  "header": "retail-module__fNDrra__header",
  "headerRow": "retail-module__fNDrra__headerRow",
  "hero": "retail-module__fNDrra__hero",
  "identity": "retail-module__fNDrra__identity",
  "imageButton": "retail-module__fNDrra__imageButton",
  "legalCompany": "retail-module__fNDrra__legalCompany",
  "legalName": "retail-module__fNDrra__legalName",
  "legalRights": "retail-module__fNDrra__legalRights",
  "legalSeparator": "retail-module__fNDrra__legalSeparator",
  "loadMore": "retail-module__fNDrra__loadMore",
  "navLinks": "retail-module__fNDrra__navLinks",
  "navigation": "retail-module__fNDrra__navigation",
  "paymentCard": "retail-module__fNDrra__paymentCard",
  "paymentFallback": "retail-module__fNDrra__paymentFallback",
  "paymentLogo": "retail-module__fNDrra__paymentLogo",
  "paymentTitle": "retail-module__fNDrra__paymentTitle",
  "payments": "retail-module__fNDrra__payments",
  "platformBar": "retail-module__fNDrra__platformBar",
  "platformIcon": "retail-module__fNDrra__platformIcon",
  "platformLogo": "retail-module__fNDrra__platformLogo",
  "price": "retail-module__fNDrra__price",
  "productBody": "retail-module__fNDrra__productBody",
  "productCard": "retail-module__fNDrra__productCard",
  "productCategory": "retail-module__fNDrra__productCategory",
  "productGrid": "retail-module__fNDrra__productGrid",
  "productMedia": "retail-module__fNDrra__productMedia",
  "productStatus": "retail-module__fNDrra__productStatus",
  "reference": "retail-module__fNDrra__reference",
  "results": "retail-module__fNDrra__results",
  "search": "retail-module__fNDrra__search",
  "section": "retail-module__fNDrra__section",
  "sectionHeading": "retail-module__fNDrra__sectionHeading",
  "socials": "retail-module__fNDrra__socials",
  "srOnly": "retail-module__fNDrra__srOnly",
  "storefront": "retail-module__fNDrra__storefront",
  "textButton": "retail-module__fNDrra__textButton",
  "topbar": "retail-module__fNDrra__topbar",
  "topbarLeft": "retail-module__fNDrra__topbarLeft",
  "topbarRight": "retail-module__fNDrra__topbarRight",
  "topbarStatus": "retail-module__fNDrra__topbarStatus",
  "topbarWithStatus": "retail-module__fNDrra__topbarWithStatus",
});
